<script lang="ts">
  interface Props {
    zips: string[];   // bindable — original entered zips
    zones: string[];  // bindable — resolved zone codes
  }
  let { zips = $bindable(), zones = $bindable() }: Props = $props();

  let text = $state(zips.join('\n'));
  let resolved = $state<Record<string, string>>({});
  let missing = $state<string[]>([]);
  let pending = $state(false);
  let debounceTimer: ReturnType<typeof setTimeout> | null = null;

  function csrfToken(): string {
    return (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content ?? '';
  }

  $effect(() => {
    if (debounceTimer) clearTimeout(debounceTimer);
    const entered = text.split(/[\s,]+/).map(s => s.trim()).filter(Boolean);
    zips = entered;
    if (entered.length === 0) {
      resolved = {}; missing = []; zones = [];
      return;
    }
    debounceTimer = setTimeout(() => resolve(entered), 400);
  });

  async function resolve(entered: string[]) {
    pending = true;
    try {
      const r = await fetch('/triggers/resolve_zips', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken(),
          'Accept': 'application/json'
        },
        body: JSON.stringify({ zips: entered })
      });
      const data = await r.json();
      resolved = data.resolved ?? {};
      missing = data.missing ?? [];
      zones = data.zones ?? [];
    } finally {
      pending = false;
    }
  }
</script>

<label for="zips">ZIPs you cover (separated by spaces, commas, or new lines):</label>
<textarea id="zips" bind:value={text} rows="5" placeholder="10463 10471 10468"></textarea>

{#if pending}
  <p class="status">Resolving…</p>
{:else if zones.length > 0}
  <p class="status">
    → Resolved to {zones.length} NWS {zones.length === 1 ? 'zone' : 'zones'}
    (forecast + county): <code>{zones.join(', ')}</code>
  </p>
{/if}

{#if missing.length > 0}
  <p class="status missing">
    Couldn't find NWS zones for: <code>{missing.join(', ')}</code>
  </p>
{/if}

<style>
  textarea { width: 100%; font-family: monospace; }
  .status { color: #666; font-size: .9rem; margin: .25rem 0; }
  .status.missing { color: #b04040; }
</style>
